var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 181.85,
    height: 124.673,
    viewBox: "0 0 181.85 124.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 6.701,
    cy: 6.701,
    r: 6.701
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5369",
    "data-name": "Rectangle 5369",
    width: 148.962,
    height: 124.314,
    transform: "translate(148.962 124.314) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46457",
    "data-name": "Path 46457",
    d: "M135.786,46.985c-1.078-2.08-5.623-1.232-6.085-1.155-.924.154-5.006.924-6.085,4.082a5.581,5.581,0,0,0-.154,2.927c.462.154,7.163,2.388,10.706-1.155C135.247,50.528,136.556,48.372,135.786,46.985Z",
    transform: "translate(-123.336 -45.594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46466",
    "data-name": "Path 46466",
    d: "M135.663,47.4a9.527,9.527,0,0,1-4.775,3.62,9.919,9.919,0,0,1-7.394-.693c-.231,2-.462,4.082-.693,6.085,0,0,8.4,5.238,14.4-2.311C136.664,51.867,136.2,49.634,135.663,47.4Z",
    transform: "translate(-122.8 -47.4)",
    fill: "#0d3b66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instant_payment-19",
    "data-name": "Instant payment-19",
    transform: "translate(-8.2 -6.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14464",
    "data-name": "Group 14464",
    transform: "translate(110.486 19.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46437",
    "data-name": "Path 46437",
    d: "M193.567,67.9H147.046a5.523,5.523,0,0,1-5.546-5.546V29.546A5.523,5.523,0,0,1,147.046,24h46.522a5.523,5.523,0,0,1,5.546,5.546V62.357A5.523,5.523,0,0,1,193.567,67.9Z",
    transform: "translate(-141.115 -23.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46438",
    "data-name": "Path 46438",
    d: "M195.686,68.173H144.7a3.7,3.7,0,0,1-3.7-3.7V27.2a3.7,3.7,0,0,1,3.7-3.7h50.989a3.7,3.7,0,0,1,3.7,3.7V64.4A3.765,3.765,0,0,1,195.686,68.173ZM144.7,24.193a3.008,3.008,0,0,0-3,3V64.4a3.008,3.008,0,0,0,3,3h50.989a3.008,3.008,0,0,0,3-3V27.2a3.008,3.008,0,0,0-3-3Z",
    transform: "translate(-141 -23.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14502",
    "data-name": "Group 14502",
    transform: "translate(117.11 26.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14467",
    "data-name": "Group 14467",
    transform: "translate(0.308 0.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14466",
    "data-name": "Group 14466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14465",
    "data-name": "Group 14465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46439",
    "data-name": "Path 46439",
    d: "M150,58.363V37.644a4.553,4.553,0,0,1,4.544-4.544h37.587a4.553,4.553,0,0,1,4.544,4.544V58.363a4.553,4.553,0,0,1-4.544,4.544H154.544A4.5,4.5,0,0,1,150,58.363Z",
    transform: "translate(-150 -33.1)",
    fill: "#95b8d1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14469",
    "data-name": "Group 14469",
    transform: "translate(24.416 7.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14468",
    "data-name": "Group 14468"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5365",
    "data-name": "Rectangle 5365",
    width: 22.414,
    height: 0.616,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14471",
    "data-name": "Group 14471",
    transform: "translate(40.591 2.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14470",
    "data-name": "Group 14470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46440",
    "data-name": "Path 46440",
    d: "M202.3,36.978a1.078,1.078,0,1,0,1.078-1.078A1.1,1.1,0,0,0,202.3,36.978Z",
    transform: "translate(-202.3 -35.9)",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14473",
    "data-name": "Group 14473",
    transform: "translate(36.278 2.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14472",
    "data-name": "Group 14472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46441",
    "data-name": "Path 46441",
    d: "M196.7,36.978a1.078,1.078,0,1,0,1.078-1.078A1.053,1.053,0,0,0,196.7,36.978Z",
    transform: "translate(-196.7 -35.9)",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14475",
    "data-name": "Group 14475",
    transform: "translate(31.887 2.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14474",
    "data-name": "Group 14474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46442",
    "data-name": "Path 46442",
    d: "M191,36.978a1.078,1.078,0,1,0,1.078-1.078A1.053,1.053,0,0,0,191,36.978Z",
    transform: "translate(-191 -35.9)",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14491",
    "data-name": "Group 14491",
    transform: "translate(3.158 2.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14488",
    "data-name": "Group 14488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14485",
    "data-name": "Group 14485",
    transform: "translate(0.308 0.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14482",
    "data-name": "Group 14482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14481",
    "data-name": "Group 14481"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 6.701,
    cy: 6.701,
    r: 6.701,
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14487",
    "data-name": "Group 14487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14486",
    "data-name": "Group 14486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46443",
    "data-name": "Path 46443",
    d: "M154.008,42.717a.331.331,0,0,1-.308-.308,7.035,7.035,0,0,1,7.009-7.009,6.7,6.7,0,0,1,4.929,2.08.272.272,0,1,1-.385.385,6.427,6.427,0,0,0-10.937,4.544A.331.331,0,0,1,154.008,42.717Z",
    transform: "translate(-153.7 -35.4)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46444",
    "data-name": "Path 46444",
    d: "M161.728,51.44a6.671,6.671,0,0,1-3.466-.924c-.154-.077-.154-.231-.077-.385s.231-.154.385-.077a6.754,6.754,0,0,0,3.235.847,6.377,6.377,0,0,0,6.393-6.393.308.308,0,1,1,.616,0A7.138,7.138,0,0,1,161.728,51.44Z",
    transform: "translate(-154.719 -37.422)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_46445",
    "data-name": "Path 46445",
    d: "M163.475,40.624V39.7a3.938,3.938,0,0,0-3.62,2.465H158.7v.924h.924v.924H158.7v.924h1.155a3.785,3.785,0,0,0,3.62,2.465v-.924a2.861,2.861,0,0,1-2.542-1.54h2.234v-.924h-2.542c0-.154-.077-.308-.077-.462a.977.977,0,0,1,.077-.462h2.542v-.924h-2.234A2.775,2.775,0,0,1,163.475,40.624Z",
    transform: "translate(-154.849 -36.388)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14493",
    "data-name": "Group 14493",
    transform: "translate(5.469 18.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14492",
    "data-name": "Group 14492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46446",
    "data-name": "Path 46446",
    d: "M193.363,58.665h-35.43a1.217,1.217,0,0,1-1.232-1.232h0a1.217,1.217,0,0,1,1.232-1.232h35.43a1.217,1.217,0,0,1,1.232,1.232h0A1.217,1.217,0,0,1,193.363,58.665Z",
    transform: "translate(-156.7 -56.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14495",
    "data-name": "Group 14495",
    transform: "translate(19.179 25.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14494",
    "data-name": "Group 14494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46447",
    "data-name": "Path 46447",
    d: "M184.2,66.994h-8.858a.855.855,0,0,1-.847-.847h0a.855.855,0,0,1,.847-.847H184.2a.855.855,0,0,1,.847.847h0A.855.855,0,0,1,184.2,66.994Z",
    transform: "translate(-174.5 -65.3)",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14497",
    "data-name": "Group 14497",
    transform: "translate(32.812 25.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14496",
    "data-name": "Group 14496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46448",
    "data-name": "Path 46448",
    d: "M201.9,66.994h-8.858a.855.855,0,0,1-.847-.847h0a.855.855,0,0,1,.847-.847H201.9a.855.855,0,0,1,.847.847h0A.855.855,0,0,1,201.9,66.994Z",
    transform: "translate(-192.2 -65.3)",
    fill: "#cc745f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14499",
    "data-name": "Group 14499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14498",
    "data-name": "Group 14498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46449",
    "data-name": "Path 46449",
    d: "M192.039,63.124H156.763a.308.308,0,1,1,0-.616h35.276a4.224,4.224,0,0,0,4.236-4.236V37.552a4.224,4.224,0,0,0-4.236-4.236H154.452a4.224,4.224,0,0,0-4.236,4.236V50.338a.308.308,0,1,1-.616,0V37.552a4.832,4.832,0,0,1,4.852-4.852h37.587a4.832,4.832,0,0,1,4.852,4.852V58.271A4.832,4.832,0,0,1,192.039,63.124Z",
    transform: "translate(-149.6 -32.7)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14501",
    "data-name": "Group 14501",
    transform: "translate(5.161 17.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14500",
    "data-name": "Group 14500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46450",
    "data-name": "Path 46450",
    d: "M193.271,58.881H157.84a1.545,1.545,0,0,1-1.54-1.54.308.308,0,1,1,.616,0,.89.89,0,0,0,.924.924h35.43a.924.924,0,1,0,0-1.849H188.5a.308.308,0,0,1,0-.616h4.775a1.54,1.54,0,0,1,0,3.081Z",
    transform: "translate(-156.3 -55.8)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "man_3_00000037661114487667885080000013381843658842193849_",
    transform: "translate(20.694 6.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_1_00000178170642224558795460000000958089307474866314_",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14505",
    "data-name": "Group 14505",
    transform: "translate(24.862 37.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14504",
    "data-name": "Group 14504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14503",
    "data-name": "Group 14503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46451",
    "data-name": "Path 46451",
    d: "M56.7,90.122A68.166,68.166,0,0,0,69.794,92.9c9.474,1,17.638,1.926,23.8-2.619,3.851-2.85,6.085-9.089,10.321-21.489,1.926-5.7,3.312-10.552,4.236-13.787a39.528,39.528,0,0,0-8.7,6.239A41.888,41.888,0,0,0,88.51,78.415l-.231.693h0L63.4,71.252C61.167,77.491,58.934,83.806,56.7,90.122Z",
    transform: "translate(-56.7 -55)",
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14507",
    "data-name": "Group 14507",
    transform: "translate(70.306 7.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14506",
    "data-name": "Group 14506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46452",
    "data-name": "Path 46452",
    d: "M115.7,24.025V24.1a3.678,3.678,0,0,0,1.232,2.157,2.688,2.688,0,0,0,.693.462,13.39,13.39,0,0,0,3.851,1.078c2,.154,8.4.616,9.089,3.312.154.693-.154,1.54.154,3.543a21.265,21.265,0,0,0,.616,2.85c.308-.077.693-.154,1-.231.154-.154.308-.385.539-.616a25.175,25.175,0,0,0,1.463-2.157,13.007,13.007,0,0,0,1.772-4.159c0-.154.077-.308.077-.462a12.324,12.324,0,0,0,0-4.929c-.385-1.849-.847-4.159-2.927-5.392a6.4,6.4,0,0,0-5.238-.154,3.716,3.716,0,0,0-4.082-2.619,3.47,3.47,0,0,0-2.619,2.773,3.3,3.3,0,0,0-1.232-.385C116.624,18.941,115.7,21.791,115.7,24.025Z",
    transform: "translate(-115.7 -16.732)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14510",
    "data-name": "Group 14510",
    transform: "translate(61.364 95.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14509",
    "data-name": "Group 14509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14508",
    "data-name": "Group 14508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46453",
    "data-name": "Path 46453",
    d: "M105.947,131.3q-1.964,39.744-1.849,79.487c.077,17.253.385,34.583,1.078,51.836,7.24-.231,14.557-.385,21.8-.616-.231-13.017-.385-23.569-.462-30.5-.154-22.876-.308-35.661.462-52.144.308-6.316,1.078-22.491,1.078-22.491h0c.077,13.325.154,26.65.308,39.975.077,8.627.308,2.542.847,56.535.077,4.082.077,7.394.077,9.474,8.935-.308,17.792-.616,26.727-.847q-3.35-64.468-6.7-129.013C134.83,132.455,120.35,131.916,105.947,131.3Z",
    transform: "translate(-104.092 -131.3)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14512",
    "data-name": "Group 14512",
    transform: "translate(59.03 50.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14511",
    "data-name": "Group 14511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46454",
    "data-name": "Path 46454",
    d: "M101.4,96.04c-.154,0-.231-.077-.308-.231a.37.37,0,0,1,.154-.462,14.814,14.814,0,0,0,2.388-1.386c3.7-2.773,5.931-8.858,10.167-21.335a.365.365,0,1,1,.693.231C110.18,85.488,107.946,91.65,104.018,94.5a15.978,15.978,0,0,1-2.465,1.463C101.553,96.04,101.476,96.04,101.4,96.04Z",
    transform: "translate(-101.061 -72.373)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14515",
    "data-name": "Group 14515",
    transform: "translate(60.939 37.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14514",
    "data-name": "Group 14514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14513",
    "data-name": "Group 14513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46455",
    "data-name": "Path 46455",
    d: "M103.817,111.858a19.206,19.206,0,0,0,.847,1.772c.462.924.77,1.695,1,2.08,13.248-.308,26.65-.385,40.283-.231,1.078,0,2.08,0,3.158.077a7.386,7.386,0,0,0,2.619-3.466c1-2.927-.616-5.469-1.463-8.858-.847-3.543-.539-5.392-.462-10.783.077-3.7.154-7.086.154-10.09v-.616c0-2.773,0-5.238-.154-7.471a58.824,58.824,0,0,0-.616-5.931,1.812,1.812,0,0,0-.154-.616,13.938,13.938,0,0,0-4.005-7.933c-3.081-2.85-6.932-3.389-12.324-4.082a39.185,39.185,0,0,0-18.871,2.311c-.231,1.772-.77,5.238-1.463,9.7,0,.231-.077.385-.077.616-.77,4.852-1.694,10.783-2.7,16.868,0,.231-.077.385-.077.616-.154,1.155-.385,2.311-.616,3.466-1.772,10.706-2.08,11.476-2.465,12.478C105.049,105.388,102.739,108.392,103.817,111.858Z",
    transform: "translate(-103.539 -55.402)",
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14518",
    "data-name": "Group 14518",
    transform: "translate(76.187 29.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14517",
    "data-name": "Group 14517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46456",
    "data-name": "Path 46456",
    d: "M135.786,46.985c-1.078-2.08-5.623-1.232-6.085-1.155-.924.154-5.006.924-6.085,4.082a5.581,5.581,0,0,0-.154,2.927c.462.154,7.163,2.388,10.706-1.155C135.247,50.528,136.556,48.372,135.786,46.985Z",
    transform: "translate(-123.336 -45.594)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14516",
    "data-name": "Group 14516",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_5367",
    "data-name": "Rectangle 5367",
    width: 13.864,
    height: 13.864,
    transform: "translate(-0.259 -5.079)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQ4jWNk5RX6z4AH/P78jhGfPAwQNIhYwEQNQxiGr0GgCBkNo1GDRg3CC3AWWqSUU78/v2MEABAcDCIN2jS2AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14521",
    "data-name": "Group 14521",
    transform: "translate(82.552 36.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14520",
    "data-name": "Group 14520",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14519",
    "data-name": "Group 14519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46458",
    "data-name": "Path 46458",
    d: "M131.6,56.826a1.926,1.926,0,1,0,1.926-1.926A1.907,1.907,0,0,0,131.6,56.826Z",
    transform: "translate(-131.6 -54.9)",
    fill: "#3e37cb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14523",
    "data-name": "Group 14523",
    transform: "translate(78.239 22.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14522",
    "data-name": "Group 14522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46459",
    "data-name": "Path 46459",
    d: "M134.872,37.2V51.372c0,1.309-1.309,2.388-3,2.619a10.064,10.064,0,0,1-2.157,0H129.4c-1.694-.231-3-1.309-3-2.619V37.2Z",
    transform: "translate(-126.092 -36.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46460",
    "data-name": "Path 46460",
    d: "M130.544,54.261a3.75,3.75,0,0,1-.924-.077h-.308c-1.926-.231-3.312-1.463-3.312-2.927V37.085a.364.364,0,0,1,.385-.385h8.4a.364.364,0,0,1,.385.385V51.257c0,1.463-1.386,2.7-3.312,2.927A7.921,7.921,0,0,1,130.544,54.261Zm-3.851-16.868V51.257c0,1.078,1.155,2.08,2.7,2.234h.308a9.388,9.388,0,0,0,2.08,0c1.54-.154,2.7-1.155,2.7-2.234V37.393Z",
    transform: "translate(-126 -36.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14524",
    "data-name": "Group 14524",
    transform: "translate(71.947 16.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46461",
    "data-name": "Path 46461",
    d: "M133.376,33.4c-.154-.616-.693-1.386-1.309-1.463a1.34,1.34,0,0,0-1.078.385,2.076,2.076,0,0,0-.616-.539c-.231-.077-.539-.385-1.232-.77-2.542-1.463-4.082-2.388-5.7-2.08-.385.077-.616.231-1.849.539a3.131,3.131,0,0,1-1.694.231,2.627,2.627,0,0,1-1.54-1,38.637,38.637,0,0,0,.231,8.781c.385,2.619.924,4.467,2.311,5.931a4.7,4.7,0,0,0,1.926,1.309c1.694.462,3.158-.462,4.852-1.54,1.386-.847,2.773-1.694,3.312-3.389a9.878,9.878,0,0,0,.231-2.157v-.693a4.659,4.659,0,0,0,1.386-1.386A2.59,2.59,0,0,0,133.376,33.4Z",
    transform: "translate(-117.919 -28.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46462",
    "data-name": "Path 46462",
    d: "M123.661,45.159a3.866,3.866,0,0,1-.924-.154,4.073,4.073,0,0,1-2.08-1.386c-1.54-1.617-2.08-3.543-2.465-6.162a42.463,42.463,0,0,1-.231-8.858c0-.154.077-.231.231-.308a.281.281,0,0,1,.385.154,2.091,2.091,0,0,0,1.309.924c.231.077.462,0,1.54-.231a10.284,10.284,0,0,0,1.309-.385c.231-.077.308-.077.539-.154,1.772-.385,3.466.616,6.008,2.08a5.524,5.524,0,0,1,.847.539,1.063,1.063,0,0,1,.308.231,1.381,1.381,0,0,1,.539.385,1.925,1.925,0,0,1,1.078-.308,2.05,2.05,0,0,1,1.617,1.694h0a3.263,3.263,0,0,1-.77,2.542,5.607,5.607,0,0,1-1.309,1.386v.462a12.561,12.561,0,0,1-.231,2.311c-.616,1.772-2.08,2.7-3.466,3.543C126.434,44.312,125.047,45.159,123.661,45.159ZM118.5,29.446a38.666,38.666,0,0,0,.308,7.933c.385,2.465.847,4.313,2.234,5.777a4.011,4.011,0,0,0,1.772,1.232c1.54.385,2.927-.462,4.544-1.54a6.614,6.614,0,0,0,3.158-3.158,8.4,8.4,0,0,0,.231-2.08v-.693c0-.077.077-.231.154-.231a3.985,3.985,0,0,0,1.232-1.309,2.778,2.778,0,0,0,.693-2,1.549,1.549,0,0,0-1-1.155,1.434,1.434,0,0,0-.847.308c-.077.077-.154.077-.308.077-.077,0-.154-.077-.231-.154l-.462-.462c-.154-.077-.231-.154-.385-.231a5.525,5.525,0,0,0-.847-.539c-2.465-1.463-4.005-2.388-5.469-2-.154,0-.231.077-.462.154a9.081,9.081,0,0,1-1.386.385,3.63,3.63,0,0,1-1.849.231A2.814,2.814,0,0,1,118.5,29.446Z",
    transform: "translate(-117.831 -28.261)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14527",
    "data-name": "Group 14527",
    transform: "translate(73.386 21.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14526",
    "data-name": "Group 14526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14525",
    "data-name": "Group 14525"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 0.539,
    cy: 0.539,
    r: 0.539,
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14530",
    "data-name": "Group 14530",
    transform: "translate(78.316 21.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14529",
    "data-name": "Group 14529",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14528",
    "data-name": "Group 14528"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 0.539,
    cy: 0.539,
    r: 0.539,
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14532",
    "data-name": "Group 14532",
    transform: "translate(82.687 18.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14531",
    "data-name": "Group 14531",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46463",
    "data-name": "Path 46463",
    d: "M132.8,30.5a.569.569,0,0,0-.539.77,3.761,3.761,0,0,1,.077,2.08c-.231.77-.385,1.54-.539,2a.551.551,0,0,0,.385.693h0a.551.551,0,0,0,.693-.385c.539-1.463,1.926-5.315,2.311-5.161Z",
    transform: "translate(-131.775 -30.494)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14535",
    "data-name": "Group 14535",
    transform: "translate(75.697 27.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14534",
    "data-name": "Group 14534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14533",
    "data-name": "Group 14533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46464",
    "data-name": "Path 46464",
    d: "M122.7,42.77a3.769,3.769,0,0,0,2.388-.154,2.479,2.479,0,0,0,1-.616,1.922,1.922,0,0,1-.308,2.234,2.062,2.062,0,0,1-1.694.231A2.195,2.195,0,0,1,122.7,42.77Z",
    transform: "translate(-122.7 -42)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14539",
    "data-name": "Group 14539",
    transform: "translate(75.774 31.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14538",
    "data-name": "Group 14538",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14537",
    "data-name": "Group 14537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46465",
    "data-name": "Path 46465",
    d: "M135.663,47.4a9.527,9.527,0,0,1-4.775,3.62,9.919,9.919,0,0,1-7.394-.693c-.231,2-.462,4.082-.693,6.085,0,0,8.4,5.238,14.4-2.311C136.664,51.867,136.2,49.634,135.663,47.4Z",
    transform: "translate(-122.8 -47.4)",
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14546",
    "data-name": "Group 14546",
    transform: "translate(121.292 81.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14541",
    "data-name": "Group 14541",
    transform: "translate(3.633 14.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14540",
    "data-name": "Group 14540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46467",
    "data-name": "Path 46467",
    d: "M200.559,137.9c0,.616.539,9.166-1.695,11.63a3.065,3.065,0,0,1-2,1.155,2.381,2.381,0,0,1-2.08-.77,6.083,6.083,0,0,1-.385-1.772h0a3.266,3.266,0,0,1-2.388.231,2.132,2.132,0,0,1-1.386-1.463,2.154,2.154,0,0,1,.308-1.463,3.059,3.059,0,0,1-2.542,0,2.645,2.645,0,0,1-1.155-1.772c-.462-1.54-.231-3.158,1-6.316,1.232-3.235,1.849-4.852,2.542-5.238C192.934,131.045,196.939,133.433,200.559,137.9Z",
    transform: "translate(-186.705 -131.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46468",
    "data-name": "Path 46468",
    d: "M196.539,150.891a2.637,2.637,0,0,1-2.08-.924,4.478,4.478,0,0,1-.385-1.463,3.137,3.137,0,0,1-2.234,0,2.413,2.413,0,0,1-1.617-1.694,1.871,1.871,0,0,1,0-.924,2.86,2.86,0,0,1-2.08-.231,2.993,2.993,0,0,1-1.309-2c-.462-1.617-.231-3.235,1-6.547,1.309-3.389,1.849-4.929,2.7-5.392,2.311-1.155,6.393,1.155,10.167,5.777a.283.283,0,0,1,.077.231c.077.924.462,9.32-1.772,11.861a3.579,3.579,0,0,1-2.157,1.309Zm-2.157-3.235h.154c.077.077.154.154.154.231A15.05,15.05,0,0,0,195,149.5a1.843,1.843,0,0,0,1.772.616,3.048,3.048,0,0,0,1.772-1.078c2-2.234,1.617-10.167,1.617-11.245-3.543-4.236-7.317-6.547-9.243-5.546-.616.308-1.309,2.08-2.388,5.006-1.155,3.081-1.386,4.621-1,6.085a2.683,2.683,0,0,0,1,1.54,2.733,2.733,0,0,0,2.234,0,.339.339,0,0,1,.385.077.344.344,0,0,1,0,.385,1.525,1.525,0,0,0-.231,1.155,1.591,1.591,0,0,0,1.155,1.155,2.779,2.779,0,0,0,2.08-.154C194.228,147.656,194.305,147.656,194.382,147.656Z",
    transform: "translate(-186.613 -131.418)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14542",
    "data-name": "Group 14542",
    transform: "translate(11.228 20.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46469",
    "data-name": "Path 46469",
    d: "M196.8,150.122h-.077c-.154-.077-.308-.231-.231-.385.154-.693.385-1.309.539-1.849.693-2.157,1.309-4.159.462-8.7,0-.154.077-.385.308-.385.154,0,.385.077.385.308a15.256,15.256,0,0,1-.462,9.012c-.154.616-.385,1.155-.539,1.849C197.033,149.968,196.956,150.122,196.8,150.122Z",
    transform: "translate(-196.473 -138.8)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14543",
    "data-name": "Group 14543",
    transform: "translate(7.685 18.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46470",
    "data-name": "Path 46470",
    d: "M192.2,146.946h-.077a.374.374,0,0,1-.231-.462c1-3.158,1.772-7.933,1.386-9.7a.318.318,0,1,1,.616-.154c.385,1.926-.385,6.7-1.386,10.09A.344.344,0,0,1,192.2,146.946Z",
    transform: "translate(-191.873 -136.373)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14545",
    "data-name": "Group 14545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14544",
    "data-name": "Group 14544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46471",
    "data-name": "Path 46471",
    d: "M193.036,114.772c1.232,1.463,2.927,3.543,4.852,6.239,3.389,4.852,5.161,7.317,6.008,10.552,1.849,6.932-.616,15.25-3.851,16.021a2.915,2.915,0,0,1-3-.924,3.117,3.117,0,0,1,0-2.542c.385-.693,2.619-4.621,1-8.241-1.155-2.465-3.928-4.467-4.467-4.005-.154.077-.154.308-.077.847.616,3,2.234,4.313,2,6.316-.077.539-.154,1.078-.462,1.309-1.386.77-5.392-3.7-7.779-7.163a24.607,24.607,0,0,1-4.621-11.014,23.048,23.048,0,0,1,.616-9.166C186.412,113.462,189.724,114.078,193.036,114.772Z",
    transform: "translate(-182.019 -112.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46472",
    "data-name": "Path 46472",
    d: "M199.152,147.824a2.966,2.966,0,0,1-2.542-1.155,3.05,3.05,0,0,1,0-2.85c.616-1.078,2.465-4.7,1-8.01-1-2.234-3.389-3.851-3.928-3.851a2.033,2.033,0,0,0,.077.539,16.218,16.218,0,0,0,1.155,3.158,5.528,5.528,0,0,1,.847,3.235c-.077.616-.154,1.232-.693,1.54-1.926,1.078-6.7-5.084-8.241-7.317a25.492,25.492,0,0,1-4.7-11.168,22.5,22.5,0,0,1,.616-9.32c.077-.154.231-.308.385-.231l9.859,1.849c.077,0,.154.077.231.077q2.542,3,4.852,6.239c3.466,4.929,5.161,7.394,6.085,10.629,1.463,5.315.385,11.091-1.386,14.1a4.165,4.165,0,0,1-3.62,2.542Zm-5.546-16.637a.463.463,0,0,1,.308.077,8.536,8.536,0,0,1,4.236,4.236c1.617,3.62-.385,7.471-1,8.627a2.522,2.522,0,0,0-.077,2.157,2.787,2.787,0,0,0,2.619.77,4.014,4.014,0,0,0,2.234-2.08c1.694-2.85,2.7-8.472,1.309-13.556-.847-3.158-2.542-5.546-5.931-10.4-1.463-2.08-3.081-4.159-4.7-6.085l-9.4-1.772a22.088,22.088,0,0,0-.462,8.7,23.6,23.6,0,0,0,4.544,10.86c2.773,4.082,6.393,7.625,7.317,7.086.231-.154.231-.539.308-1a5.672,5.672,0,0,0-.77-2.85,13.594,13.594,0,0,1-1.232-3.312c-.154-.539-.154-1,.154-1.232A1.024,1.024,0,0,1,193.607,131.187Z",
    transform: "translate(-181.896 -112.373)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14549",
    "data-name": "Group 14549",
    transform: "translate(97.34 40.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14548",
    "data-name": "Group 14548",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14547",
    "data-name": "Group 14547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46473",
    "data-name": "Path 46473",
    d: "M150.8,63.04c0,3.774,6.7,23.261,6.7,23.261l11.63,26.265c15.867.462,23.107-7.7,23.107-7.7L173.291,84.452l-.308-.385-.077-.077c-.693-1.309-10.167-19.641-15.944-23.03C150.954,57.494,150.8,63.04,150.8,63.04Z",
    transform: "translate(-150.8 -59.82)",
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14550",
    "data-name": "Group 14550",
    transform: "translate(5.576 43.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46474",
    "data-name": "Path 46474",
    d: "M55.615,72.074h0s-1.232-4.929-3.312-7.7c-2-2.85-2.7.539-1.694,2.234.77,1.309.693,3.543.847,4.852-1.155.231-2.7.462-4.7.847C40.21,73.46,32.2,75.694,32.2,75.694c7.625,3.928,3.389,15.4,8.858,15.4,5.469-.077,15.25-2.234,17.484-6.855C60.236,80.7,57.155,74.693,55.615,72.074Z",
    transform: "translate(-31.785 -62.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46475",
    "data-name": "Path 46475",
    d: "M40.857,91.295c-2.85,0-3.312-2.773-3.851-5.931-.616-3.543-1.309-7.548-5.161-9.551-.154-.077-.231-.231-.154-.308,0-.154.154-.231.231-.308.077,0,8.164-2.234,14.634-3.389,1.849-.308,3.312-.616,4.39-.77a2.132,2.132,0,0,0-.077-.693,9.307,9.307,0,0,0-.77-3.7c-.693-1.078-.693-3.158.154-3.7.462-.308,1.155-.308,2.157,1.078a29.845,29.845,0,0,1,3.312,7.779c1.849,3.158,4.621,8.858,2.927,12.4-2.234,4.7-11.861,7.009-17.792,7.086ZM33,75.659c3.543,2.311,4.236,6.316,4.775,9.628.539,3.389,1,5.315,3.158,5.315h.077c5.854-.077,15.1-2.388,17.176-6.624,1.617-3.389-1.463-9.4-2.927-11.784v-.077a26.574,26.574,0,0,0-3.235-7.625c-.616-.847-1-1-1.155-.924-.385.231-.539,1.772.077,2.773a9.814,9.814,0,0,1,.847,4.005c0,.385.077.693.077.924,0,.154-.077.385-.308.385-1.155.231-2.7.462-4.7.847C41.473,73.426,35.157,75.043,33,75.659Z",
    transform: "translate(-31.661 -62.785)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14573",
    "data-name": "Group 14573",
    transform: "translate(3.995 37.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14552",
    "data-name": "Group 14552",
    transform: "translate(0.465 0.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14551",
    "data-name": "Group 14551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46476",
    "data-name": "Path 46476",
    d: "M48.38,91.317l10.629-6.393a2.723,2.723,0,0,0,.924-3.7l-14.1-23.415a2.723,2.723,0,0,0-3.7-.924L31.512,63.281a2.723,2.723,0,0,0-.924,3.7l14.1,23.415A2.741,2.741,0,0,0,48.38,91.317Z",
    transform: "translate(-30.211 -56.511)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14554",
    "data-name": "Group 14554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14553",
    "data-name": "Group 14553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46477",
    "data-name": "Path 46477",
    d: "M46.855,92.025a2.62,2.62,0,0,1-.77-.077,3.219,3.219,0,0,1-2-1.463L30.064,67.147a3.225,3.225,0,0,1,1.078-4.39l10.629-6.393a3.258,3.258,0,0,1,2.388-.385,3.219,3.219,0,0,1,2,1.463l14.1,23.415a3.225,3.225,0,0,1-1.078,4.39L48.549,91.64A4.2,4.2,0,0,1,46.855,92.025ZM43.389,56.9a1.768,1.768,0,0,0-1.078.308L31.681,63.6a2.221,2.221,0,0,0-.77,3l14.1,23.415a2.424,2.424,0,0,0,1.309,1,1.988,1.988,0,0,0,1.617-.231L58.562,84.4a2.221,2.221,0,0,0,.77-3l-14.1-23.415a2.424,2.424,0,0,0-1.309-1A1.311,1.311,0,0,0,43.389,56.9Z",
    transform: "translate(-29.607 -55.906)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14557",
    "data-name": "Group 14557",
    transform: "translate(5.001 5.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14556",
    "data-name": "Group 14556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14555",
    "data-name": "Group 14555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46478",
    "data-name": "Path 46478",
    d: "M49.271,65.917a6.806,6.806,0,0,1,.924,2.465A7.478,7.478,0,0,1,50.2,71a7,7,0,0,1-2.927,4.467,6.205,6.205,0,0,1-2.542,1.078,2.133,2.133,0,0,1-.693.077,2.132,2.132,0,0,0-.693.077h-.693c-.231,0-.462-.077-.693-.077a7.53,7.53,0,0,1-2.7-1.155,7.687,7.687,0,0,1-2-2.157L36.87,72.7A2.736,2.736,0,0,0,36.562,72l-.231-.693c-.077-.231-.077-.462-.154-.693a5.924,5.924,0,0,1,.231-2.85,6.676,6.676,0,0,1,1.309-2.542,6.821,6.821,0,0,1,2.157-1.772,6.922,6.922,0,0,1,5.238-.539,6.523,6.523,0,0,1,2.311,1.155A5.305,5.305,0,0,1,49.271,65.917Zm-.077.077a6.749,6.749,0,0,0-1.772-1.849,6.359,6.359,0,0,0-2.311-1.078,5.672,5.672,0,0,0-2.542-.077,7.993,7.993,0,0,0-2.388.847,6.482,6.482,0,0,0-1.849,1.695,6.359,6.359,0,0,0-1.078,2.311,5.672,5.672,0,0,0-.077,2.542,8.832,8.832,0,0,0,.847,2.388,6.482,6.482,0,0,0,1.695,1.849A6.359,6.359,0,0,0,42.031,75.7a5.672,5.672,0,0,0,2.542.077,7.993,7.993,0,0,0,2.388-.847,6.482,6.482,0,0,0,1.849-1.694,6.359,6.359,0,0,0,1.078-2.311,5.672,5.672,0,0,0,.077-2.542A4.4,4.4,0,0,0,49.194,65.994Z",
    transform: "translate(-36.1 -62.623)",
    fill: "#0d3b66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14561",
    "data-name": "Group 14561",
    transform: "translate(7.494 5.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14560",
    "data-name": "Group 14560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14559",
    "data-name": "Group 14559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14558",
    "data-name": "Group 14558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46479",
    "data-name": "Path 46479",
    d: "M46.087,73.742a.618.618,0,0,1-.616.077l-5.623-2a.78.78,0,1,1,.539-1.463l4.775,1.694,1.155-8.935a.741.741,0,0,1,1.463.231L46.472,73.2a.891.891,0,0,1-.385.539Z",
    transform: "translate(-39.337 -62.485)",
    fill: "#15cc74"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14563",
    "data-name": "Group 14563",
    transform: "translate(10.82 16.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46480",
    "data-name": "Path 46480",
    d: "M55.32,78.776l-10.475,6.47a.829.829,0,0,1-1.078-.231h0A.829.829,0,0,1,44,83.937l10.475-6.47a.829.829,0,0,1,1.078.231h0A.7.7,0,0,1,55.32,78.776Z",
    transform: "translate(-43.656 -77.356)",
    fill: "#222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14565",
    "data-name": "Group 14565",
    transform: "translate(12.592 19.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14564",
    "data-name": "Group 14564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46481",
    "data-name": "Path 46481",
    d: "M57.62,82.476l-10.475,6.47a.829.829,0,0,1-1.078-.231h0a.829.829,0,0,1,.231-1.078l10.475-6.47a.829.829,0,0,1,1.078.231h0A.7.7,0,0,1,57.62,82.476Z",
    transform: "translate(-45.956 -81.056)",
    fill: "#222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14567",
    "data-name": "Group 14567",
    transform: "translate(14.44 22.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14566",
    "data-name": "Group 14566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46482",
    "data-name": "Path 46482",
    d: "M60.02,86.253,49.545,92.646a.829.829,0,0,1-1.078-.231h0a.829.829,0,0,1,.231-1.078l10.475-6.47a.829.829,0,0,1,1.078.231h0A.932.932,0,0,1,60.02,86.253Z",
    transform: "translate(-48.356 -84.756)",
    fill: "#222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14569",
    "data-name": "Group 14569",
    transform: "translate(16.212 25.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14568",
    "data-name": "Group 14568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46483",
    "data-name": "Path 46483",
    d: "M62.32,89.976l-10.475,6.47a.829.829,0,0,1-1.078-.231h0A.829.829,0,0,1,51,95.137l10.475-6.47a.829.829,0,0,1,1.078.231h0A.829.829,0,0,1,62.32,89.976Z",
    transform: "translate(-50.656 -88.556)",
    fill: "#222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14572",
    "data-name": "Group 14572",
    transform: "translate(9.448 8.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14571",
    "data-name": "Group 14571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14570",
    "data-name": "Group 14570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46484",
    "data-name": "Path 46484",
    d: "M46.284,75.31a.694.694,0,0,1-.385-.077l-3.774-1.309a.365.365,0,1,1,.231-.693L46.13,74.54c.154.077.231,0,.385,0a.4.4,0,0,0,.154-.308l.847-6.624c0-.154.231-.308.385-.308s.308.231.308.385l-.847,6.624a1.113,1.113,0,0,1-.539.77A.7.7,0,0,1,46.284,75.31Z",
    transform: "translate(-41.873 -67.3)",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14576",
    "data-name": "Group 14576",
    transform: "translate(5.731 55.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14575",
    "data-name": "Group 14575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14574",
    "data-name": "Group 14574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46485",
    "data-name": "Path 46485",
    d: "M34.231,79.193s6.008-.385,6.008,1.926c.077,2.311-3.62,2.08-3.62,2.08a17.932,17.932,0,0,1,3.389.385,3.607,3.607,0,0,1,2.234,1.078,2.018,2.018,0,0,1,.462,1,2.077,2.077,0,0,1-1.155,2,2.807,2.807,0,0,1-1.078.154,4.237,4.237,0,0,1-.924-.077h0c1.849-.154,3.312.539,3.7,1.617a1.537,1.537,0,0,1,0,1.232,2.575,2.575,0,0,1-2.388,1.694s3.081-.616,3.62,1.155-4.236,2.234-4.236,2.234-2.619-.539-2.7-2.157.385-1.54.385-1.54S35.771,91.131,37,88.05A3.022,3.022,0,0,1,34.616,84.2C34.693,84.045,29.686,79.116,34.231,79.193Z",
    transform: "translate(-31.967 -78.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46486",
    "data-name": "Path 46486",
    d: "M40.21,95.74h0c-.154,0-2.927-.616-3-2.465a3.638,3.638,0,0,1,.154-1.463,2.621,2.621,0,0,1-.924-1.078,3.645,3.645,0,0,1,.077-2.7,3.907,3.907,0,0,1-1.772-1.232,3.464,3.464,0,0,1-.539-2.7c-.616-.616-2.85-3-2.234-4.39q.347-.924,2.08-.924h0c.308,0,4.39-.231,5.854,1.078a1.386,1.386,0,0,1,.539,1.155,2.151,2.151,0,0,1-.616,1.54,4.273,4.273,0,0,1-.616.462c.231.077.539.077.77.154a4.111,4.111,0,0,1,2.388,1.155,1.992,1.992,0,0,1,.539,1.155,2.331,2.331,0,0,1-1.078,2.157,2.633,2.633,0,0,1,1.54,1.463,2.252,2.252,0,0,1,0,1.463,2.366,2.366,0,0,1-.77,1.155,2.22,2.22,0,0,1,2.08,1.463,1.108,1.108,0,0,1-.154,1.078c-.693,1.078-3.928,1.463-4.313,1.463Zm-2.157-3.7c-.077.077-.154.385-.154,1.232.077,1.232,2,1.694,2.311,1.772,1.232-.154,3.312-.616,3.774-1.309a.977.977,0,0,0,.077-.462c-.385-1.155-2.157-1-2.927-.924-.154,0-.231.077-.385.077s-.385-.077-.385-.308c0-.154.077-.385.308-.385a1.348,1.348,0,0,0,.385-.077,1.891,1.891,0,0,0,1.694-2.388c-.231-.693-1.078-1.155-2.157-1.386H40.21c-1.078,0-1.155-.077-1.232-.231a.344.344,0,0,1,0-.385c.077-.154.231-.154.385-.154a7.472,7.472,0,0,1,1.309.077,1.813,1.813,0,0,0,.616-.154,1.449,1.449,0,0,0,.616-2.388,3.235,3.235,0,0,0-2-.924,20.037,20.037,0,0,0-3-.385h-.385a.349.349,0,0,1,.077-.693H36.9a4.12,4.12,0,0,0,2.542-.693,1.183,1.183,0,0,0,.385-1,.941.941,0,0,0-.308-.693c-1.078-.924-4.236-.924-5.315-.847h0c-.616,0-1.309.077-1.463.462-.308.77,1.078,2.7,2.234,3.774.077.077.154.231.077.308a2.832,2.832,0,0,0,.385,2.311,2.609,2.609,0,0,0,1.772,1.078c.077,0,.231.077.231.154a.234.234,0,0,1,0,.308,3.586,3.586,0,0,0-.231,2.465,2.2,2.2,0,0,0,.924,1,.424.424,0,0,1,.231.385C38.207,91.966,38.13,92.043,38.053,92.043Zm-.154,0Z",
    transform: "translate(-31.862 -78.78)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14577",
    "data-name": "Group 14577",
    transform: "translate(76.832 19.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46487",
    "data-name": "Path 46487",
    d: "M127.814,33.537h-.154a4.693,4.693,0,0,0-3-.385c-.154.077-.385-.077-.462-.231s.077-.385.231-.462a5.544,5.544,0,0,1,3.543.462.37.37,0,0,1,.154.462C128.122,33.46,127.968,33.537,127.814,33.537Z",
    transform: "translate(-124.173 -32.322)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14578",
    "data-name": "Group 14578",
    transform: "translate(71.971 19.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46488",
    "data-name": "Path 46488",
    d: "M118.2,33.3c-.154,0-.308-.077-.308-.231a.343.343,0,0,1,.231-.462,5.657,5.657,0,0,1,3.081-.154.365.365,0,0,1-.231.693,4.758,4.758,0,0,0-2.619.154Z",
    transform: "translate(-117.862 -32.277)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14579",
    "data-name": "Group 14579",
    transform: "translate(85.094 20.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46489",
    "data-name": "Path 46489",
    d: "M135.362,37.109c-.154,0-.231-.077-.308-.231a.343.343,0,0,1,.231-.462,1.244,1.244,0,0,0,.616-1.386c-.077-.154-.154-.616-.616-.539-.154,0-.385-.077-.385-.308,0-.154.077-.385.308-.385a1.215,1.215,0,0,1,1.386,1.078,1.874,1.874,0,0,1-1,2.234Z",
    transform: "translate(-134.9 -33.787)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14580",
    "data-name": "Group 14580",
    transform: "translate(74.156 21.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46490",
    "data-name": "Path 46490",
    d: "M122.857,40.406h0c-2.234-.154-2.157-.616-2.157-.847a15.125,15.125,0,0,1,1.386-4.313.344.344,0,1,1,.616.308,12.979,12.979,0,0,0-1.309,3.851,5.215,5.215,0,0,0,1.463.231.395.395,0,0,1,0,.77Z",
    transform: "translate(-120.7 -35.061)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14581",
    "data-name": "Group 14581",
    transform: "translate(73.463 8.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46491",
    "data-name": "Path 46491",
    d: "M128.658,22.043H128.5c-.154-.077-.231-.154-.231-.308a2.919,2.919,0,0,0-2.7-2.542,2.7,2.7,0,0,0-2.619,2.542c0,.154-.077.231-.231.308s-.231,0-.385-.077a3.278,3.278,0,0,0-2.157-.847h0c-.154,0-.385-.154-.385-.308a.352.352,0,0,1,.308-.385,4.852,4.852,0,0,1,2.234.616A3.275,3.275,0,0,1,125.5,18.5h.077a3.352,3.352,0,0,1,3.235,2.619,5.5,5.5,0,0,1,1.772-.77c.154-.077.385.077.462.231s-.077.385-.231.462a5.13,5.13,0,0,0-1.926,1Z",
    transform: "translate(-119.8 -18.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14583",
    "data-name": "Group 14583",
    transform: "translate(75.389 30.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14582",
    "data-name": "Group 14582",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46492",
    "data-name": "Path 46492",
    d: "M129.078,58.422a14.947,14.947,0,0,1-6.624-1.772.584.584,0,0,1-.154-.308l.693-6.085c0-.077.077-.231.154-.231a.234.234,0,0,1,.308,0,9.486,9.486,0,0,0,7.163.693,9.8,9.8,0,0,0,4.621-3.466.588.588,0,0,1,.385-.154c.154,0,.231.154.308.231l1.463,6.7a.463.463,0,0,1-.077.308A10.377,10.377,0,0,1,129.078,58.422Zm-6.085-2.234c1.309.693,8.4,4.313,13.633-2.234l-1.232-5.777a9.812,9.812,0,0,1-4.544,3.158,10.012,10.012,0,0,1-7.24-.539Z",
    transform: "translate(-122.3 -47.1)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14585",
    "data-name": "Group 14585",
    transform: "translate(60.619 49.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14584",
    "data-name": "Group 14584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46493",
    "data-name": "Path 46493",
    d: "M105.57,119.678c-.154,0-.231-.077-.308-.231-.231-.462-.616-1.232-1-2.157l-.385-.847a3.4,3.4,0,0,1-.462-1c-.847-2.773.308-5.238,1.617-7.856.385-.77.693-1.54,1-2.311.385-.924.616-1.54,2.465-12.4.231-1.155.385-2.311.616-3.466l.077-.616c.847-5.006,1.694-10.706,2.7-16.868l.077-.616c0-.154.231-.308.385-.308s.308.231.308.385l-.077.616c-.924,6.162-1.849,11.784-2.7,16.868l-.077.616c-.154,1.155-.385,2.311-.616,3.543-1.772,10.475-2.08,11.476-2.465,12.555-.308.77-.693,1.54-1.078,2.311-1.155,2.465-2.311,4.852-1.54,7.317a9.249,9.249,0,0,0,.462.924l.385.847c.385.77.693,1.463.924,1.926,13.325-.308,26.8-.385,40.052-.231,1,0,2,0,3.081.077a6.854,6.854,0,0,0,2.388-3.235c.693-2,.077-3.851-.616-6.008a22.238,22.238,0,0,1-.847-2.7.318.318,0,1,1,.616-.154c.231.924.539,1.772.77,2.619.693,2.157,1.386,4.159.616,6.393a7.629,7.629,0,0,1-2.7,3.62.283.283,0,0,1-.231.077c-1.078,0-2.08,0-3.158-.077-13.325,0-26.881.077-40.283.385Z",
    transform: "translate(-103.124 -71)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14587",
    "data-name": "Group 14587",
    transform: "translate(98.937 51.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14586",
    "data-name": "Group 14586",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46494",
    "data-name": "Path 46494",
    d: "M170.84,116.271h-1.232c-.154,0-.231-.077-.308-.231l-11.63-26.265c-.077-.077-2.85-8.318-4.775-15.019-.077-.154.077-.385.231-.462s.385.077.462.231c1.926,6.7,4.775,14.865,4.775,14.942L169.916,115.5a38.371,38.371,0,0,0,11.322-1.386c.154-.077.385.077.462.231s-.077.385-.231.462A37.3,37.3,0,0,1,170.84,116.271Z",
    transform: "translate(-152.873 -74.273)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14588",
    "data-name": "Group 14588",
    transform: "translate(56.026 60.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46495",
    "data-name": "Path 46495",
    d: "M100.5,89.95c-.154,0-.308-.077-.308-.231a6.636,6.636,0,0,0-2.85-3.312.344.344,0,1,1,.308-.616,7.468,7.468,0,0,1,3.158,3.7.343.343,0,0,1-.231.462Z",
    transform: "translate(-97.161 -85.761)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14589",
    "data-name": "Group 14589",
    transform: "translate(73.527 55.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46496",
    "data-name": "Path 46496",
    d: "M127.213,106.766c-3,0-5.7-.385-6.778-1.463a1.8,1.8,0,0,1-.462-1.849c1.078-4.005,1.849-12.247,2.234-23.646a.352.352,0,0,1,.385-.308h15.79a.512.512,0,0,1,.385.308c0,.077.616,6.316,1,12.478.77,12.786-.231,13.094-.77,13.248A69.012,69.012,0,0,1,127.213,106.766ZM122.9,80.193c-.308,8.01-.924,18.408-2.311,23.492a1.071,1.071,0,0,0,.308,1.155c2.465,2.465,16.021.539,17.869,0,1-.693.385-13.017-.77-24.647Z",
    transform: "translate(-119.882 -79.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14590",
    "data-name": "Group 14590",
    transform: "translate(8.2 130.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46497",
    "data-name": "Path 46497",
    d: "M189.665,168.57H8.585a.385.385,0,1,1,0-.77h181.08a.364.364,0,0,1,.385.385C189.973,168.339,189.819,168.57,189.665,168.57Z",
    transform: "translate(-8.2 -167.8)",
    fill: "#060e12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstant);
export default __webpack_public_path__ + "static/media/instant.11f33910751d68716cd13b80fd7fc53a.svg";
export { ForwardRef as ReactComponent };